/**
 * Sourcing / Contact page hero — trade routes between offices
 */
(function () {
  'use strict';

  function initSourcingHero(root) {
    if (root.dataset.esCanvasInit === '1') return;
    root.dataset.esCanvasInit = '1';

    var canvas = root.querySelector('[data-sourcing-hero-canvas]');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0;
    var h = 0;
    var layState = { lastW: 0, lastH: 0 };
    var stars = [];
    var hubs = [];
    var routes = [];
    var rafId = null;
    var running = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var ORANGE = '#ff6128';
    var TEAL = '#7ec8f0';

    function rand(a, b) {
      return a + Math.random() * (b - a);
    }

    function buildStars() {
      stars = [];
      var n = Math.max(60, Math.floor((w * h) / 9000));
      for (var i = 0; i < n; i++) {
        stars.push({
          x: Math.random() * w,
          y: Math.random() * h,
          r: Math.random() * 1.2 + 0.25,
          tw: rand(0, Math.PI * 2),
          sp: rand(0.4, 1.8)
        });
      }
    }

    function buildScene() {
      hubs = [
        { x: w * 0.28, y: h * 0.52, label: 'Wuxi', color: ORANGE, r: 26 },
        { x: w * 0.72, y: h * 0.48, label: 'Hangzhou', color: TEAL, r: 24 }
      ];
      routes = [
        {
          cp: { x: w * 0.5, y: h * 0.22 },
          t: rand(0, 1),
          speed: rand(0.08, 0.14)
        },
        {
          cp: { x: w * 0.5, y: h * 0.78 },
          t: rand(0.3, 0.7),
          speed: rand(0.06, 0.1)
        }
      ];
    }

    function resize() {
      var L = window.EastSupplierCanvasLayout;
      if (L) {
        var m = L.measure(canvas, root, { minW: 320, minH: 280, state: layState });
        w = m.w;
        h = m.h;
        dpr = m.dpr;
        L.applyBitmap(canvas, ctx, w, h, dpr);
      } else {
        var rect = (canvas.parentElement || root).getBoundingClientRect();
        w = Math.max(320, rect.width);
        h = Math.max(280, rect.height);
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.floor(w * dpr);
        canvas.height = Math.floor(h * dpr);
        if (canvas.style) {
          canvas.style.width = '';
          canvas.style.height = '';
        }
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      buildStars();
      buildScene();
    }

    function quadPoint(t, p0, p1, p2) {
      var u = 1 - t;
      return {
        x: u * u * p0.x + 2 * u * t * p1.x + t * t * p2.x,
        y: u * u * p0.y + 2 * u * t * p1.y + t * t * p2.y
      };
    }

    function drawBackground() {
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#061018');
      g.addColorStop(0.5, '#0e2433');
      g.addColorStop(1, '#143040');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      var rg = ctx.createRadialGradient(w * 0.5, h * 0.35, 0, w * 0.5, h * 0.4, w * 0.5);
      rg.addColorStop(0, 'rgba(255, 97, 40, 0.1)');
      rg.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = rg;
      ctx.fillRect(0, 0, w, h);
    }

    function drawStarsAnim(t) {
      stars.forEach(function (s) {
        var a = reducedMotion ? 0.55 : 0.3 + 0.5 * Math.sin(t * s.sp + s.tw);
        ctx.globalAlpha = a;
        ctx.fillStyle = '#fff';
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fill();
      });
      ctx.globalAlpha = 1;
    }

    function drawRoutes(t) {
      var a = hubs[0];
      var b = hubs[1];

      routes.forEach(function (route) {
        ctx.save();
        ctx.strokeStyle = 'rgba(126, 200, 240, 0.22)';
        ctx.lineWidth = 1.5;
        ctx.setLineDash([6, 8]);
        ctx.beginPath();
        ctx.moveTo(a.x, a.y);
        ctx.quadraticCurveTo(route.cp.x, route.cp.y, b.x, b.y);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.restore();

        if (!reducedMotion) route.t += route.speed * 0.012;
        if (route.t > 1) route.t = 0;

        var pt = quadPoint(route.t, a, route.cp, b);
        ctx.save();
        ctx.globalAlpha = 0.9;
        ctx.fillStyle = ORANGE;
        ctx.beginPath();
        ctx.arc(pt.x, pt.y, 3.5, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      });

      hubs.forEach(function (hub, idx) {
        var pulse = reducedMotion ? 0.75 : 0.6 + 0.3 * Math.sin(t * 1.4 + idx * 1.2);

        ctx.save();
        ctx.globalAlpha = pulse * 0.3;
        var grd = ctx.createRadialGradient(hub.x, hub.y, 0, hub.x, hub.y, hub.r * 2.2);
        grd.addColorStop(0, hub.color);
        grd.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = grd;
        ctx.beginPath();
        ctx.arc(hub.x, hub.y, hub.r * 2.2, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();

        ctx.save();
        ctx.globalAlpha = pulse;
        ctx.strokeStyle = hub.color;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(hub.x, hub.y, hub.r, 0, Math.PI * 2);
        ctx.stroke();
        ctx.fillStyle = '#fff';
        ctx.beginPath();
        ctx.arc(hub.x, hub.y, hub.r * 0.32, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      });
    }

    function frame(ts) {
      if (!running) return;
      var expectedW = Math.max(1, Math.floor(w * dpr));
      if (canvas.width < expectedW * 0.5 || canvas.height < Math.max(1, Math.floor(h * dpr)) * 0.5) {
        resize();
      }
      var t = ts * 0.001;
      ctx.clearRect(0, 0, w, h);
      drawBackground();
      drawStarsAnim(t);
      drawRoutes(t);
      rafId = requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      resize();
      running = true;
      rafId = requestAnimationFrame(frame);
    }

    function stop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
    }

    resize();
    window.addEventListener('resize', resize);

    if (typeof ResizeObserver !== 'undefined' && canvas.parentElement) {
      new ResizeObserver(function () {
        resize();
      }).observe(canvas.parentElement);
    }

    requestAnimationFrame(function () {
      resize();
    });

    start();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            resize();
            start();
          } else stop();
        });
      }).observe(root);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else {
        resize();
        var br = root.getBoundingClientRect();
        if (br.bottom > 0 && br.top < window.innerHeight) start();
      }
    });

    window.addEventListener('pageshow', function () {
      resize();
      start();
    });
  }

  function boot() {
    document.querySelectorAll('[data-sourcing-hero]').forEach(initSourcingHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
